import {  Heading, VStack, HStack, Box, Flex, Text, Icon, Image} from "@chakra-ui/react";
import FullScreenSection from "./FullScreenSection";
import { useState, useEffect } from "react";
import { keyframes } from "@emotion/react";


// Implement the UI for the LandingSection component according to the instructions.
// Use a combination of Avatar, Heading and VStack components.

const fadeIn = keyframes`
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
`;

const steps = [
    {
      number: "1",
      title: "Login",
      description: "Sign in with your phone number or email and password"
    },
    {
      number: "2",
      title: "Select & Choose",
      description: "Select Send Money, choose sending and receiving currencies"
    },
    {
      number: "3",
      title: "Enter Beneficiary Details",
      description: "Add recipient's bank information and account details"
    },
    {
      number: "4",
      title: "Confirm Payment",
      description: "Review details and confirm your payment"
    }
  ];


const TransferSteps = () => {
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveStep((prev) => (prev + 1) % 4);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  {/* How to Transfer Money Section */}
  return ( 
    <FullScreenSection
        justifyContent="center"
        alignItems="center"
        isDarkBackground={false}
        backgroundColor="gray.50"
        py={100}
    >
        <VStack spacing={12} width="100%" maxW="1200px">
        <Heading fontSize={{ base: "2rem", md: "2.5rem", lg: "3rem" }} fontWeight="bold" textAlign="center">
            How to Transfer Money via Swiftchang
        </Heading>
        <Text fontSize={{ base: "1rem", md: "1.1rem", lg: "1.2rem" }} color="gray.600" textAlign="center">
            Simple steps to send money globally in minutes
        </Text>

        <Flex 
            width="100%" 
            gap={12} 
            alignItems="center" 
            justifyContent="space-between"
            flexDirection={{ base: "column", md: "row" }}
        >
            {/* Steps List */}
            <VStack spacing={{ base: 5, md: 8 }} flex="1" align="stretch">
            {steps.map((step, index) => (
                <Flex
                key={index}
                direction={{ base: "column", sm: "row" }}
                align={{ base: "flex-start", sm: "center" }}
                gap={{ base: 3, sm: 4 }}
                p={{ base: 4, md: 6 }}
                bg={activeStep === index ? "gray.100" : "white"}
                borderRadius="lg"
                boxShadow={activeStep === index ? "lg" : "md"}
                border={activeStep === index ? "2px solid" : "1px solid"}
                borderColor={activeStep === index ? "black" : "gray.200"}
                transition="all 0.3s ease"
                cursor="pointer"
                onClick={() => setActiveStep(index)}
                _hover={{ boxShadow: "xl", transform: "scale(1.02)" }}
                >
                <Box
                    minW={{ base: "44px", md: "60px" }}
                    minH={{ base: "44px", md: "60px" }}
                    borderRadius="full"
                    bg={activeStep === index ? "black" : "gray.300"}
                    color="white"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    fontSize={{ base: "lg", md: "2xl" }}
                    fontWeight="bold"
                >
                    {step.number}
                </Box>
                <VStack align="flex-start" spacing={1}>
                    <Heading fontSize={{ base: "1.1rem", md: "1.3rem", lg: "1.5rem" }} fontWeight="semibold">
                    {step.title}
                    </Heading>
                    <Text color="gray.600" fontSize={{ base: "sm", md: "md" }}>{step.description}</Text>
                </VStack>
                </Flex>
            ))}
            </VStack>

            {/* Phone Mockup with Animation */}
            <Box flex="1" display={{ base: "none", md: "flex" }} justifyContent="center">
            <Box
                position="relative"
                width={{ base: "240px", md: "280px", lg: "300px" }}
                height={{ base: "480px", md: "560px", lg: "600px" }}
                borderRadius="3xl"
                border="12px solid"
                borderColor="gray.800"
                bg="white"
                boxShadow="2xl"
                overflow="hidden"
            >
                {/* Phone Notch */}
                <Box
                position="absolute"
                top="0"
                left="50%"
                transform="translateX(-50%)"
                width="150px"
                height="25px"
                bg="gray.800"
                borderBottomRadius="xl"
                zIndex="10"
                />

                {/* Phone Screen Content */}
                <Box 
                pt="30px" 
                px={4} 
                height="100%" 
                bg="gradient"
                bgGradient="linear(to-b, blue.50, white)"
                >
                {activeStep === 0 && (
                    <VStack 
                    spacing={6} 
                    animation={`${fadeIn} 0.5s ease-in-out`}
                    pt={8}
                    >
                    <Heading fontSize="2xl" color="black">Login</Heading>
                    <VStack spacing={4} width="100%">
                        <Box 
                        width="100%" 
                        height="50px" 
                        bg="white" 
                        borderRadius="md" 
                        border="2px solid"
                        borderColor="black"
                        display="flex"
                        alignItems="center"
                        px={4}
                        position="relative"
                        >
                        <Text color="gray.800" fontSize="sm">user@email.com</Text>
                        <Box
                            position="absolute"
                            right="4"
                            width="2px"
                            height="20px"
                            bg="black"
                            animation="blink 1s infinite"
                            sx={{
                            "@keyframes blink": {
                                "0%, 100%": { opacity: 1 },
                                "50%": { opacity: 0 }
                            }
                            }}
                        />
                        </Box>
                        <Box 
                        width="100%" 
                        height="50px" 
                        bg="white" 
                        borderRadius="md" 
                        border="1px solid"
                        borderColor="gray.300"
                        display="flex"
                        alignItems="center"
                        px={4}
                        >
                        <Text color="gray.800" fontSize="sm">••••••••</Text>
                        </Box>
                        <Box 
                        width="100%" 
                        height="50px" 
                        bg="black" 
                        borderRadius="md"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        cursor="pointer"
                        transition="all 0.2s"
                        _hover={{ transform: "scale(0.98)" }}
                        >
                        <Text color="white" fontWeight="bold">Login</Text>
                        </Box>
                    </VStack>
                    </VStack>
                )}

                {activeStep === 1 && (
                    <VStack 
                    spacing={6} 
                    animation={`${fadeIn} 0.5s ease-in-out`}
                    pt={8}
                    >
                    <Heading fontSize="2xl" color="black">Send Money</Heading>
                    <VStack spacing={4} width="100%">
                        <Box 
                        width="100%" 
                        p={4} 
                        bg="white" 
                        borderRadius="md"
                        boxShadow="sm"
                        border="2px solid"
                        borderColor="black"
                        >
                        <Text fontSize="sm" color="gray.600" mb={2}>From</Text>
                        <HStack justify="space-between">
                            <HStack>
                            <Image src="/flags/ca.svg" alt="Canada flag" boxSize="30px" />
                            <Text fontWeight="bold" fontSize="lg">CAD</Text>
                            </HStack>
                            <Text fontWeight="bold" fontSize="xl" color="black">500</Text>
                        </HStack>
                        </Box>
                        <Box 
                        width="100%" 
                        p={4} 
                        bg="white" 
                        borderRadius="md"
                        boxShadow="sm"
                        >
                        <Text fontSize="sm" color="gray.600" mb={2}>To</Text>
                        <HStack justify="space-between">
                            <HStack>
                            <Image src="/flags/ng.svg" alt="Nigeria flag" boxSize="30px" />
                            <Text fontWeight="bold" fontSize="lg">NGN</Text>
                            </HStack>
                            <Text fontWeight="bold" fontSize="xl" color="black">525,000</Text>
                        </HStack>
                        </Box>
                        <Box 
                        width="100%" 
                        height="50px" 
                        bg="black" 
                        borderRadius="md"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        cursor="pointer"
                        transition="all 0.2s"
                        _hover={{ transform: "scale(0.98)" }}
                        >
                        <Text color="white" fontWeight="bold">Continue</Text>
                        </Box>
                    </VStack>
                    </VStack>
                )}

                {activeStep === 2 && (
                    <VStack 
                    spacing={6} 
                    animation={`${fadeIn} 0.5s ease-in-out`}
                    pt={8}
                    >
                    <Heading fontSize="xl" color="black">Beneficiary Details</Heading>
                    <VStack spacing={4} width="100%">
                        <Box 
                        width="100%" 
                        p={3} 
                        bg="white" 
                        borderRadius="md"
                        boxShadow="sm"
                        border="2px solid"
                        borderColor="black"
                        >
                        <Text fontSize="xs" color="gray.600" mb={1}>Recipient Name</Text>
                        <HStack>
                            <Text fontWeight="semibold" fontSize="sm">Ikemba Onyeoma</Text>
                            <Box
                            width="2px"
                            height="16px"
                            bg="black"
                            animation="blink 1s infinite"
                            />
                        </HStack>
                        </Box>
                        <Box 
                        width="100%" 
                        p={3} 
                        bg="white" 
                        borderRadius="md"
                        boxShadow="sm"
                        >
                        <Text fontSize="xs" color="gray.600" mb={1}>Bank Name</Text>
                        <Text fontWeight="semibold" fontSize="sm">Opay</Text>
                        </Box>
                        <Box 
                        width="100%" 
                        p={3} 
                        bg="white" 
                        borderRadius="md"
                        boxShadow="sm"
                        >
                        <Text fontSize="xs" color="gray.600" mb={1}>Account Number</Text>
                        <Text fontWeight="semibold" fontSize="sm">8012345678</Text>
                        </Box>
                        <Box 
                        width="100%" 
                        height="50px" 
                        bg="black" 
                        borderRadius="md"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        cursor="pointer"
                        transition="all 0.2s"
                        _hover={{ transform: "scale(0.98)" }}
                        >
                        <Text color="white" fontWeight="bold">Continue</Text>
                        </Box>
                    </VStack>
                    </VStack>
                )}

                {activeStep === 3 && (
                    <VStack 
                    spacing={6} 
                    animation={`${fadeIn} 0.5s ease-in-out`}
                    pt={8}
                    >
                    <Heading fontSize="2xl" color="black">Confirm</Heading>
                    <VStack spacing={4} width="100%">
                        <Box 
                        width="100%" 
                        p={4} 
                        bg="white" 
                        borderRadius="md"
                        boxShadow="sm"
                        >
                        <Text fontSize="sm" color="gray.600">Beneficiary</Text>
                        <Text fontWeight="bold" mt={1}>Ikemba Onyeoma</Text>
                        <Text fontSize="xs" color="gray.500" mt={1}>Opay - 8012345678</Text>
                        </Box>
                        <Box 
                        width="100%" 
                        p={4} 
                        bg="white" 
                        borderRadius="md"
                        boxShadow="sm"
                        >
                        <Text fontSize="sm" color="gray.600">Amount</Text>
                        <HStack mt={1}>
                            <Image src="/flags/ca.svg" alt="Canada flag" boxSize="24px" />
                            <Text fontWeight="bold">$500.00 CAD</Text>
                        </HStack>
                        </Box>
                        <Box 
                        width="100%" 
                        p={4} 
                        bg="white" 
                        borderRadius="md"
                        boxShadow="sm"
                        >
                        <Text fontSize="sm" color="gray.600">Recipient Gets</Text>
                        <HStack mt={1}>
                            <Image src="/flags/ng.svg" alt="Nigeria flag" boxSize="24px" />
                            <Text fontWeight="bold">₦525,000 NGN</Text>
                        </HStack>
                        </Box>
                        <Box 
                        width="100%" 
                        height="50px" 
                        bg="black" 
                        borderRadius="md"
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                        cursor="pointer"
                        transition="all 0.2s"
                        _hover={{ transform: "scale(0.98)" }}
                        >
                        <Text color="white" fontWeight="bold">Confirm Payment</Text>
                        </Box>
                    </VStack>
                    </VStack>
                )}
                </Box>
            </Box>
            </Box>
        </Flex>
        </VStack>
    </FullScreenSection>)
    };

export default TransferSteps;